interface IDividerProps {
  content?: React.ReactNode;
}

export default function DividerWithText(props: IDividerProps) {
  return (
    <div className="flex items-center w-full justify-center gap-[8px]">
      <hr className="bg-base-alpha/[0.08] w-full h-[1px]" />
      {props.content}
      <hr className="bg-base-alpha/[0.08] w-full h-[1px]" />
    </div>
  );
}
